const Product_plan = {
  PRODUCT_PLAN_ACQUIRED: 'PRODUCT_PLAN_ACQUIRED',
};

export default Product_plan;
